<template>
  <div>
    <multiselect
      name="projects"
      v-model="$editNewOrder.reject_type_id"
      :options="types"
      @input="(t) => {}"
      placeholder="Выберите причину"
      track-by="id"
      label="title"
      :searchable="true"
      :multiple="false">
      <template slot="noResult">Вариант не найден, запишите свой</template>
    </multiselect>

    <input v-if="$editNewOrder.reject_type_id?.id === 0" type="text" v-model="$editNewOrder.reject_comment"
           placeholder="Укажите свою причину отказа"
           class="form-control">

  </div>
</template>
<script>

import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      types: this.$platformConstants.orderRejectReasons,
    }
  },
  computed: {
    $editNewOrder() {
      return this.$store.getters['orders/editNewOrder']
    },
  },
}
</script>
